import { render, staticRenderFns } from "./FilesList.vue?vue&type=template&id=c406988a&"
import script from "./FilesList.vue?vue&type=script&lang=js&"
export * from "./FilesList.vue?vue&type=script&lang=js&"
import style0 from "./FilesList.vue?vue&type=style&index=0&id=c406988a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports